import { Component, OnInit, OnDestroy } from '@angular/core';
import { UsersService } from '@app/services/users/users.service'; 
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { ImageCropperComponent } from '@app/shared/components/image-cropper/image-cropper.component';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import { catchError, skipWhile, Subscription, take } from 'rxjs';
import { Store } from '@ngrx/store';
import * as CoreActions from '@app/core/store/core.action'
import { selectImageProfleImageState } from '@app/modules/image/store/selectors/image.selectors';
import { SubSink } from 'subsink';
import { selectMeState } from '@app/core/store/core.selectors';
import { IUser } from '@app/models/user.interface';
import { CustomValidators } from '@app/modules/users/validators/custom-validators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-change-profile-password',
  templateUrl: './change-profile-password.component.html',
  styleUrls: ['./change-profile-password.component.scss']
})
export class ChangeProfilePasswordComponent implements OnInit {
  public form: FormGroup;
  public isHidden1 = true;
  public isHidden2 = true;
  public isHidden3 = true;

  constructor(private _fb: FormBuilder,
    private store$: Store,
    private _translation: TranslateService,
    private _toaster: ToastrService) { 

    this.form = this._fb.group({
      usrUsername: new FormControl(''),
      usrFirstName: new FormControl(''),
      usrLastName: new FormControl(''),
      usrPhone: new FormControl(''),
      usrEmail: new FormControl(['', Validators.required]),
      usrOldPassword: new FormControl('', Validators.compose([
        Validators.required
      ])),
      usrPassword: new FormControl('', Validators.compose([
        // check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // check whether the entered password has a lower case letter
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // check whether the entered password has a special character
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])),
      usrConfirmPassword: new FormControl('', Validators.compose([
        // check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // check whether the entered password has a lower case letter
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // check whether the entered password has a special character
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])),
      usrIsPrivileged: new FormControl(0)
    });

    
  }

  ngOnInit(): void {
  }

  changePassword() {
    if(!this.form.controls['usrOldPassword'].invalid && !this.form.controls['usrPassword'].invalid && !this.form.controls['usrConfirmPassword'].invalid){
      this.store$.dispatch(CoreActions.changePassword({ form: this.form.value }))
      //this._toaster.success(this._translation.instant('user.profile.passwordChanged'));    
    }
  }
  

}
